import { render, staticRenderFns } from "./ElFlipCard.vue?vue&type=template&id=6969e4de"
import script from "./ElFlipCard.vue?vue&type=script&lang=js"
export * from "./ElFlipCard.vue?vue&type=script&lang=js"
import style0 from "./ElFlipCard.vue?vue&type=style&index=0&id=6969e4de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports